import { render, staticRenderFns } from "./ProductPromotionPopupIframe.vue?vue&type=template&id=6d44867b&"
import script from "./ProductPromotionPopupIframe.vue?vue&type=script&lang=ts&"
export * from "./ProductPromotionPopupIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports